import React from 'react'
import { useStoreConfig } from 'config/hooks/useStoreConfig'
import { JsonLdScript } from '../JsonLdScript/JsonLdScript'

export const Organization = ({
    asPath
}: {
    asPath: string
}): JSX.Element | null => {
    const { seo } = useStoreConfig()
    if (
        !seo.organization ||
        asPath !== seo.organization.allowedPath ||
        !seo.organization.content
    ) {
        return null
    }
    const content = { ...seo.organization.content }

    const data = {
        '@context': content['@context'],
        '@type': content['@type'],
        legalname: content.legalname,
        url: content.url,
        address: content.address,
        logo: content.logo,
        name: content.name,
        description: content.description,
        email: content.email,
        sameAs: content.sameAs,
        contactPoint: {
            '@type': 'ContactPoint',
            telephone: content.contactPoint?.[0]?.telephone || '',
            contactType: content.contactPoint?.[0]?.contactType || '',
            contactOption: content.contactPoint?.[0]?.contactOption || '',
            areaServed: content.contactPoint?.[0]?.areaServed || 'US',
            availableLanguage:
                content.contactPoint?.[0]?.availableLanguage || 'en'
        }
    }

    return <JsonLdScript id="cms-organization-json-ld" data={data} />
}
